import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import AudioStudyIcon from '../../../assets/img/icons/studyMethods/audioStudy.svg';
import ByReferenceIcon from '../../../assets/img/icons/studyMethods/byReference.svg';
import DailyQuizIcon from '../../../assets/img/icons/studyMethods/dailyQuiz.svg';
import PersonalizedStudyIcon from '../../../assets/img/icons/studyMethods/personalizedStudyPlan.svg';
import PracticeExamIcon from '../../../assets/img/icons/studyMethods/practiceExam.svg';
// import StudyAllIcon from '../../../assets/img/icons/studyMethods/studyAll.svg';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import { Desktop, Mobile, Tablet } from '../../Common/const';
import WarfareModal from '../../PracticeExam/WarfareModal';

class StudyHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      mainTitle: 'How do you best study?',
      changed: false,
      openModal: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (window.screen.width < 800) {
      this.props.checkDailyQuizStatus();
    }
  }

  // handleOnStudyAll = () => {
  //   if (this.props.warfarePlan) {
  //     this.setState({
  //       openModal: true,
  //     });
  //   } else {
  //     this.setState({
  //       mainTitle: 'Study All',
  //       changed: true,
  //     });
  //     this.props.setBackTo('/app/question');
  //     this.props.history('/app/question');
  //   }
  // };

  handleOnStudyByReference = () => {
    let el = document.getElementById('references');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // If the element does not yet exist, force its rendering by waiting for a tick
      setTimeout(() => {
        el = document.getElementById('references'); // search again
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  handleOnPracticeExamPage = () => {
    this.props.history('/app/exams');
  };
  // handleOnWarfareQuars = () => {
  //   // Google Analytics 4
  //   ReactGA4.event({
  //     category: 'Select',
  //     action: 'Quals & Certs',
  //     label: 'Quals & Certs',
  //   });
  //   this.setState({
  //     mainTitle: 'Quals and Certs',
  //     changed: true,
  //   });
  //   this.props.history('/app/study/quals-and-certs');
  // };

  handleOnBackButton = () => {
    this.setState({
      mainTitle: 'How do you best study?',
      changed: false,
    });
    this.props.history(-1);
  };

  handleOnDailyQuizClick = () => {
    if (this.props.warfarePlan) {
      this.setState({
        openModal: true,
      });
    } else {
      this.props.history('/app/daily20quiz');
    }
  };

  handleOnDailyQuizPageClick = () => {
    this.props.history('/app/daily-quiz');
  };

  handleOnAudioStudy = () => {
    this.props.history('/app/audio-study');
  };

  handleOnPersonalizedStudy = () => {
    this.props.history('/app/personalized-study');
  };

  getDailyQuizButtonText = () => {
    const { checkDailyQuizStatusWaiting, dailyQuizRunning, nextQuizIn } =
      this.props;

    if (checkDailyQuizStatusWaiting) {
      // MUST LAUNCH cHECK STATUS ACTION FRO  HERE TOO
      return <CircularLoading className="button-loading-gif" />;
    }
    if (dailyQuizRunning) {
      return `${dailyQuizRunning} QUESTIONS REMAINING`;
    }
    if (nextQuizIn > 0) {
      return `NEXT QUIZ IN ${this.getMinutesOrHours(nextQuizIn)}`;
    }
    if (nextQuizIn === -1) {
      return 'QUIZ NOT AVAILABLE';
    }
    return 'DAILY 20 QUIZ NOW AVAILABLE';
  };

  getMinutesOrHours(hours) {
    if (hours > 0 && hours < 1) {
      const minutes = Math.ceil(hours * 60);
      if (minutes === 1) {
        return `${minutes} Min`;
      }
      return `${minutes} Mins`;
    }
    if (hours === 1) {
      return `${hours} HR`;
    }
    return `${hours} HRS`;
  }

  render() {
    const { checkDailyQuizStatusWaiting, nextQuizIn } = this.props;

    const enabledButton =
      !checkDailyQuizStatusWaiting && (nextQuizIn !== -1 || nextQuizIn > 0);

    return (
      <div>
        <div
          className={
            this.state.changed === false
              ? 'study-header-body pl-md-4 pb-md-4'
              : 'study-header-body-changed pl-sm-4'
          }
        >
          {/* Title header */}
          <Row className="title-bar mr-0 ml-0">
            <div className="title-text-large">{this.state.mainTitle}</div>
            <div className="title-text-responsive mt-3">Study</div>
            <div className="title-text-responsive-secondary mt-0">
              How do you best study?
            </div>
          </Row>

          {/* Images header */}
          {this.state.changed === false ? (
            <Row className="image-row mr-0 ml-md-0">
              {/* The first 4 Cols are for the mobile resolution, the other ones are for the desktop mode  */}

              <Mobile>
                <Col
                  sm={3}
                  className="rounded d-md-none mr-3 bg-blue-ligth"
                  onClick={this.handleOnPersonalizedStudy}
                >
                  <div className="image-text-mobile">Personalized Study</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={PersonalizedStudyIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>

                {/* <Col
                  sm={3}
                  className="rounded d-md-none mr-3 bg-item"
                  onClick={this.handleOnStudyAll}
                >
                  <div className="image-text-mobile">Study All</div>
                  <img
                    className="image-item-mobile b-0 l-0  svg-props mb-2 mr-2"
                    src={StudyAllIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col> */}
                <Col
                  sm={3}
                  className="rounded d-md-none mr-3 bg-green"
                  onClick={this.handleOnStudyByReference}
                >
                  <div className="image-text-mobile">By Reference</div>
                  <img
                    className="image-item-mobile b-0 l-0 svg-props mb-2 mr-2"
                    src={ByReferenceIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>
                <Col
                  sm={3}
                  className="rounded d-md-none mr-3 bg-blue"
                  onClick={this.handleOnAudioStudy}
                >
                  <div className="image-text-mobile">Audio Study</div>
                  <img
                    className="image-item-mobile b-0 l-0 svg-props mb-2 mr-2"
                    src={AudioStudyIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>
                <Col
                  sm={3}
                  className="rounded d-md-none mr-3 bg-red"
                  onClick={this.handleOnDailyQuizPageClick}
                >
                  <div className="image-text-mobile">Daily Quiz</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={DailyQuizIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>
                <Col
                  sm={3}
                  className="rounded d-md-none mr-3 bg-purple"
                  onClick={this.handleOnPracticeExamPage}
                >
                  <div className="image-text-mobile">Practice Exam</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={PracticeExamIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>
                {/* <Col
                  sm={3}
                  className="rounded d-md-none mr-3 bg-item"
                  onClick={this.handleOnWarfareQuars}
                >
                  <div className="image-text-mobile">Quals & Certs</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={WarfareIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col> */}
              </Mobile>

              <Tablet>
                <Col
                  sm={3}
                  className="rounded d-lg-none mr-3 bg-blue-ligth"
                  onClick={this.handleOnPersonalizedStudy}
                >
                  <div className="image-text-mobile">Personalized Study</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={PersonalizedStudyIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>

                {/* <Col
                  sm={3}
                  className="rounded d-lg-none mr-3 bg-item"
                  onClick={this.handleOnStudyAll}
                >
                  <div className="image-text-mobile">Study All</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={StudyAllIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col> */}
                <Col
                  sm={3}
                  className="rounded d-lg-none mr-3 bg-green"
                  onClick={this.handleOnStudyByReference}
                >
                  <div className="image-text-mobile">By Reference</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={ByReferenceIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>
                <Col
                  sm={3}
                  className="rounded d-lg-none mr-3 bg-blue"
                  onClick={this.handleOnAudioStudy}
                >
                  <div className="image-text-mobile">Audio Study</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={AudioStudyIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>
                <Col
                  sm={3}
                  className="rounded d-lg-none mr-3 bg-red"
                  onClick={this.handleOnDailyQuizPageClick}
                >
                  <div className="image-text-mobile">Daily Quiz</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={DailyQuizIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>
                <Col
                  sm={3}
                  className="rounded d-lg-none mr-3 bg-purple"
                  onClick={this.handleOnPracticeExamPage}
                >
                  <div className="image-text-mobile">Practice Exam</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={PracticeExamIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col>
                {/* <Col
                  sm={3}
                  className="rounded d-lg-none mr-3 bg-item"
                  onClick={this.handleOnWarfareQuars}
                >
                  <div className="image-text-mobile">Quals & Certs</div>
                  <img
                    className="image-item-mobile b-0 l-0"
                    src={WarfareIcon}
                    loading="lazy"
                    alt="..."
                  />
                </Col> */}
              </Tablet>

              <Desktop>
                <Col
                  md={3}
                  onClick={this.handleOnPersonalizedStudy}
                  className="pr-md-0 image-responsive"
                >
                  <div className="image-text">Personalized Study</div>
                  <div className="image-item bg-blue-ligth">
                    <img
                      className="svg-props mb-2 mr-2"
                      src={PersonalizedStudyIcon}
                      alt="..."
                    />
                  </div>
                </Col>
                {/* <Col
                  md={3}
                  onClick={this.handleOnStudyAll}
                  className="pr-md-0 image-responsive"
                >
                  <div className="image-text" data-test="study-all-button">
                    Study All
                  </div>
                  <div className="image-item bg-item">
                    <img
                      className="svg-props mb-2 mr-2"
                      src={StudyAllIcon}
                      alt="..."
                    />
                  </div>
                </Col> */}
                <Col
                  md={3}
                  onClick={this.handleOnStudyByReference}
                  className="pr-md-0 image-responsive"
                >
                  <div className="image-text">References</div>
                  <div className="image-item bg-green">
                    <img
                      className="svg-props mb-2 mr-2"
                      src={ByReferenceIcon}
                      alt="..."
                    />
                  </div>
                </Col>
                <Col
                  md={3}
                  onClick={this.handleOnAudioStudy}
                  className="pr-md-0 image-responsive"
                >
                  <div className="image-text" data-test="audio-study-button">
                    Audio Study
                  </div>
                  <div className="image-item bg-blue">
                    <img
                      className="svg-props mb-2 mr-2"
                      src={AudioStudyIcon}
                      alt="..."
                    />
                  </div>
                </Col>
                <Col
                  md={3}
                  onClick={this.handleOnDailyQuizPageClick}
                  className="pr-md-0 image-responsive"
                >
                  <div className="image-text" data-test="daily-quiz-button">
                    Daily Quiz
                  </div>
                  <div className="image-item  bg-red">
                    <img
                      className="svg-props mb-2 mr-2"
                      src={DailyQuizIcon}
                      alt="..."
                    />
                  </div>
                </Col>
                <Col
                  md={3}
                  onClick={this.handleOnPracticeExamPage}
                  className="pr-md-0 image-responsive"
                >
                  <div className="image-text">Practice Exam</div>
                  <div className="image-item bg-purple">
                    <img
                      className="svg-props mb-2 mr-2"
                      src={PracticeExamIcon}
                      alt="..."
                    />
                  </div>
                </Col>
                {/* <Col
                  md={3}
                  onClick={this.handleOnWarfareQuars}
                  className="pr-md-0 image-responsive"
                >
                  <div className="image-text">Quals & Certs</div>
                  <div className="image-item bg-item">
                    <img
                      className="svg-props mb-2 mr-2"
                      src={WarfareIcon}
                      alt="..."
                    />
                  </div>
                </Col> */}
              </Desktop>
              {this.state.openModal && (
                <WarfareModal
                  open={this.state.openModal}
                  closeModal={() => this.setState({ openModal: false })}
                />
              )}
            </Row>
          ) : (
            ''
          )}

          {/* Last Row : Mobile resolution only */}
          <Row
            className={
              enabledButton
                ? 'last-row-style-study d-lg-none'
                : 'last-row-style-study d-lg-none row-disabled'
            }
          >
            <div
              className="last-row-text mt-1"
              onClick={enabledButton ? this.handleOnDailyQuizClick : null}
            >
              {this.getDailyQuizButtonText()}
              {enabledButton && (
                <div className="arrow-right">
                  <i className="material-icons material-next">
                    keyboard_arrow_right
                  </i>
                </div>
              )}
            </div>

            {/* <div className="last-row-text choose-qual-btn mt-1">
              <Link
                to="/app/account-settings"
                onClick={() =>
                  this.props.setFlashSectionChoose({
                    value: true,
                    typeChoose: 'Qual',
                  })
                }
              >
                CHOOSE QUAL
              </Link>
            </div> */}
          </Row>
        </div>
        <Desktop>
          <div className="gradient-divider" />
        </Desktop>
      </div>
    );
  }
}

StudyHeader.propTypes = {
  handleOnClickTopics: PropTypes.func,
  handleOnClickStudyAll: PropTypes.func,
  handleOnClickQualsAndCerts: PropTypes.func,
};

export default StudyHeader;
